"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncFlatMap = exports.asyncReduce = void 0;
function asyncReduce(array, cb, initialValue) {
    return array.reduce(async (prev, curr, currentIndex, arr) => cb(await prev, curr, currentIndex, arr), Promise.resolve(initialValue));
}
exports.asyncReduce = asyncReduce;
async function asyncFlatMap(array, cb) {
    return (await Promise.all(array.map(cb))).flat();
}
exports.asyncFlatMap = asyncFlatMap;
//# sourceMappingURL=array.js.map